import BigNumber from 'bignumber.js'
const formatNumber = n => {
  return n - 10 >= 0 ? n : "0" + n;
};
let util = {
  accSubtr(arg1, arg2) {
    return ((arg1 * 1000 - arg2 * 1000) / 1000).toFixed(2);
  },
  // 弱提示
  showToast(title = "", duration = 1500, position = "middle", iconClass) {
    Toast({
      message: title,
      position: position,
      duration: duration,
      iconClass: iconClass
    });
  },
  // 加载中
  showLoading(text = "加载中...", spinnerType = "fading-circle") {
    Indicator.open({
      text: text,
      spinnerType: spinnerType
    });
    setTimeout(()=>{this.hideLoading()},20000)
  },
  hideLoading() {
    Indicator.close();
  },
  // 模态弹框
  showModal(
    title = "",
    mess = "",
    showCancelButton = true,
    confirmButtonText = "确定",
    call,
    cancelcall
  ) {
    MessageBox({
      title: title,
      message: mess,
      showCancelButton: showCancelButton,
      confirmButtonText: confirmButtonText,
      confirmButtonClass: "btnSure"
    }).then(action => {
      if (action === "confirm") {
        typeof call === "function" && call();
      } else {
        typeof cancelcall === "function" && cancelcall();
      }
    });
  },
  // 获取当前日期前后几天的日期
  getDayText(index) {
    var day = index;
    var today = new Date();
    var targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetdayMilliseconds);
    // var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    return formatNumber(tMonth) + "." + formatNumber(tDate);
  },

  // 转换成标准时间
  beijingDay(beijingTimeInMillis){
    if(beijingTimeInMillis){

      var timezoneOffset =new Date().getTimezoneOffset()
      // console.log('beijingTimeInMillis === ' + timezoneOffset)
      var date = new Date(beijingTimeInMillis)
      // console.log('date === ' + date)
      date.setTime(date.getTime() + timezoneOffset * 60 * 1000 + 480 * 60 * 1000);
      //  console.log('date === ' + date)
      return date
    }

    return new Date()
  },
  formatTime(date, status) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const weekIndex = date.getDay();
    const weekList = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
    const weekList1 = [
      "周日",
      "周一",
      "周二",
      "周三",
      "周四",
      "周五",
      "周六"
    ];
    switch (status) {
      case 0:
        return (
          formatNumber(month) +
          "月" +
          formatNumber(day) +
          "日 " +
          formatNumber(hour) +
          ":" +
          formatNumber(minute)
        );
      case 1:
        return (
          formatNumber(day) +
          "天" +
          formatNumber(hour) +
          "小时" +
          formatNumber(minute) +
          "分"
        );
      case 2:
        return [minute, second].map(formatNumber).join(":");
      case 22:
        return [hour, minute].map(formatNumber).join(":");
      case 23:
        return [hour, minute, second].map(formatNumber).join(":");
      case 25:
        return `${year}年${formatNumber(month)}月${formatNumber(day)}日 ${
          weekList[weekIndex]
        }`;
      case 255:
        return `${year}-${formatNumber(month)}-${formatNumber(day)} ${
          weekList1[weekIndex]
        }`;
      case 3:
        return minute * 60 + second;
      case 24:
        return [month, day].map(formatNumber).join("-");
      case 4:
        return [year, month, day].map(formatNumber).join("-");
      case 20:
        return [year, month, day].map(formatNumber).join("/");
      case 44:
        return [year, month].map(formatNumber).join("-");
      case 45:
        return [year, month].map(formatNumber).join("/");
      case 5:
        if (month + 3 < 12) {
          return [year, month + 3, day].map(formatNumber).join("-");
        } else {
          return [year + 1, month - 9, day].map(formatNumber).join("-");
        }
      case 6:
        return [year, month, day].map(formatNumber).join(".");
      case 66:
        return [year, month, 1].map(formatNumber).join(".");
      case 7:
        return formatNumber(day) + "天" + formatNumber(hour) + "小时";
      case 8:
        return (
          [year, month, day].map(formatNumber).join(".") +
          " " +
          [hour, minute].map(formatNumber).join(":")
        );
      case 9:
        return (
          [year, month, day].map(formatNumber).join(".") +
          " " +
          [hour, minute, second].map(formatNumber).join(":")
        );
      case 10:
        return (
          [year, month, day].map(formatNumber).join("-") +
          " " +
          [hour, minute].map(formatNumber).join(":")
        );
      case 11:
        return (
          [year, month, day].map(formatNumber).join("-") +
          " " +
          [hour, minute, second].map(formatNumber).join(":")
        );
      case 15:
        return formatNumber(month) + "月";
      case 16:
        return year;
      case 17:
        return {
          year: formatNumber(year),
          month: formatNumber(month),
          day: formatNumber(day)
        };
      case 18:
        return formatNumber(year) + "年" + formatNumber(month) + "月";
      case 181:
        return formatNumber(year) + "年" + formatNumber(month) + "月" + formatNumber(day) + "日";
      case 19:
        return (
          [year, month, day].map(formatNumber).join("/") +
          " " +
          [hour, minute].map(formatNumber).join(":")
        );
      default:
        return (
          [year, month, day].map(formatNumber).join("/") +
          " " +
          [hour, minute, second].map(formatNumber).join(":")
        );
    }
  },
  // 剩余时间
  lastTime(value) {
    var secondTime = formatNumber(parseInt(value % 60)); // 秒
    var minuteTime = formatNumber(parseInt(value / 60)); // 分
    var hourTime = formatNumber(parseInt(value / (60 * 60))); // 时
    var result = "" + secondTime + "秒";
    if (minuteTime > 0) {
      result = "" + minuteTime + "分" + result;
    }
    if (hourTime > 0) {
      result = "" + hourTime + "小时" + result;
    }
    return result;
  },
  // 计算停车时长
  selvateTime(value) {
    var minuteTime = parseInt(value % 60); // 分
    var hourTime = parseInt(value / 60%24); // 时
    var day = parseInt(value / (24*60)); // 天
    var result = ""
    if (minuteTime > 0) {
      result = "" + (minuteTime?minuteTime:'0') + "分钟" + result;
    }
    if (hourTime > 0) {
      result = "" + (hourTime?hourTime:'0') + "小时" + result;
    }
    if (day > 0) {
      result = "" + (day?day:'0') + "天" + result;
    }
    return result;
  },
  compare(property) {
    return function(a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;
    };
  },
  // YYYY-MM-DD几天后的日期
  targetDay(day, type) {
    var today = new Date();
    var targetDay = new Date().valueOf() + 1000 * 24 * 60 * 60 * day;
    today.setTime(targetDay);
    var tYear = today.getFullYear();
    var tMonth =
      today.getMonth() + 1 < 10
        ? "0" + (today.getMonth() + 1)
        : today.getMonth() + 1;
    var tDay = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
    if (type == "date") {
      return tYear + "-" + tMonth + "-" + tDay;
    } else if (type == "day") {
      return tDay;
    }
  },
  add(arg1, arg2) {
    return (arg1 * 1000 + arg2 * 1000) / 1000;
  },
  lastTimeCount(time){
    let nowTime = new Date().getTime();
    if(nowTime <= time){
      //获取时间差
      let timediff=Math.round((time-nowTime)/1000);
      //获取还剩多少分钟
      let minute=parseInt(timediff/60%60)>=10?parseInt(timediff/60%60):'0'+parseInt(timediff/60%60);
      //获取还剩多少秒
      let second=timediff%60>=10?timediff%60:'0'+timediff%60;
      return minute+':'+second
    }else{
      return 0
    }
  },
  //加法
   plus(x, y, a) {
    x = Number(x) || 0
    y = Number(y) || 0
    if (a) {
      return new BigNumber(x).plus(y).decimalPlaces(a).toNumber()
    } else {
      return new BigNumber(x).plus(y).toNumber()
    }
  },
  //减法
  minus(x, y, a) {
    x = Number(x) || 0
    y = Number(y) || 0
    //x减数，y被减数，a精确位数
    if (a) {
      return new BigNumber(x).minus(y).decimalPlaces(a).toNumber()
    } else {
      return new BigNumber(x).minus(y).toNumber()
    }
  },
  //乘法
  multipliedBy(x, y, a) {
    x = Number(x) || 0
    y = Number(y) || 0
    if (a) {
      return new BigNumber(x).multipliedBy(y).decimalPlaces(a).toNumber()
    } else {
      return new BigNumber(x).multipliedBy(y).toNumber()
    }
  },
  //除法
  div(x, y, a = 2) {
    x = Number(x) || 0
    y = Number(y) || 0
    //x除数，y被除数，a精确位数
    if (a) {
      return new BigNumber(x).div(y).decimalPlaces(a).toNumber()
    } else {
      return new BigNumber(x).div(y).toNumber()
    }
  },
  priceFormat(val){
    if(val){
        return Number(val).toFixed(2)
    }else{
        return '0.00'
    }
  },
  // 正则验证车牌,验证通过返回true,不通过返回false
  isLicensePlate(str){
    const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼台][A-Z](?:[A-Z0-9]{5,6}|[A-Z0-9]{4,5}(?:挂|学|警|港澳|使领))$/
    // const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][0-9A-Z挂学警港澳使领]{5,6}$/
    return reg.test(str)
  },
  distance(nowLatitude,nowlongitude,latitude,longitude){
    var nowLat = nowLatitude * Math.PI / 180.0; //经纬度转换成三角函数中度分表形式。
    var nowLng = nowlongitude * Math.PI / 180.0; //经纬度转换成三角函数中度分表形式。
    var lat = latitude * Math.PI / 180.0; //经纬度转换成三角函数中度分表形式。
    var lng = longitude * Math.PI / 180.0;
    var a = nowLat - lat;
    var b = nowLng - lng;
    var s = 2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(nowLat) * Math.cos(lat) * Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137; // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
    return s;
  },
  // 日期获取周几
  getWeek(value) {
    let end = ''
    if(!value){return ''}
    switch (
      new Date(value.replace(new RegExp(/-/gm), "/") + " 00:00:00").getDay()
    ) {
      case 1:
        end = "一";
        break;
      case 2:
        end = "二";
        break;
      case 3:
        end = "三";
        break;
      case 4:
        end = "四";
        break;
      case 5:
        end = "五";
        break;
      case 6:
        end = "六";
        break;
      case 0:
        end = "日";
        break;
      default:
    }
    return '周' + end
  },
};
export default util;
